// src/environments/environment.ts
export const environment = {
  production: false,
  apiUrl: 'http://localhost:8080/api',
  wsUrl: 'http://localhost:8080/api/ws-alerts',
  appName: 'Selquna',
  sentryDsn: ''
};
